/**
 * Password strength helper + meter bars (red → orange → green).
 */

export function getPasswordStrength(password = "") {
  const value = String(password || "");
  if (!value) {
    return { score: 0, level: "empty", filled: 0 };
  }

  let score = 0;
  if (value.length >= 6) score += 1;
  if (value.length >= 10) score += 1;
  if (/[a-z]/.test(value) && /[A-Z]/.test(value)) score += 1;
  if (/\d/.test(value)) score += 1;
  if (/[^A-Za-z0-9]/.test(value)) score += 1;

  if (score <= 2) {
    return { score, level: "weak", filled: 1 };
  }
  if (score <= 3) {
    return { score, level: "medium", filled: 2 };
  }
  return { score, level: "strong", filled: 3 };
}

/**
 * Three small strength lines under a password field.
 */
export default function PasswordStrengthMeter({ password, labels = {} }) {
  const { level, filled } = getPasswordStrength(password);
  const labelText =
    level === "weak"
      ? labels.weak || "Weak"
      : level === "medium"
        ? labels.medium || "Medium"
        : level === "strong"
          ? labels.strong || "Strong"
          : "";

  return (
    <div
      className={`fl-auth__strength fl-auth__strength--${level}`}
      aria-live="polite"
    >
      <div className="fl-auth__strength-bars" role="img" aria-label={labelText}>
        {[1, 2, 3].map((bar) => (
          <span
            key={bar}
            className={`fl-auth__strength-bar${
              bar <= filled ? " is-filled" : ""
            }`}
          />
        ))}
      </div>
      {labelText ? (
        <span className="fl-auth__strength-label">{labelText}</span>
      ) : null}
    </div>
  );
}
